import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PolicyLayout({ title, tagline, updated, sections, children }) {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="text-xs uppercase tracking-[0.2em] text-[#14A085]">Legal</div>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0F3D2E] mt-1">
        {title}
      </h1>
      {tagline && <p className="mt-3 text-[#3B5249] max-w-3xl">{tagline}</p>}
      {updated && (
        <div className="mt-3 text-xs text-[#6E877C]">Last updated: {updated}</div>
      )}

      <div className={`mt-10 grid gap-10 ${sections && sections.length > 0 ? "lg:grid-cols-[260px_1fr]" : ""}`}>
        {sections && sections.length > 0 && (
          <aside className="hidden lg:block">
            <div className="sticky top-24 rounded-xl border border-[#E2E8E5] bg-white p-4">
              <div className="text-xs uppercase tracking-[0.2em] text-[#14A085] mb-3">
                On this page
              </div>
              <nav className="space-y-1">
                {sections.map((s) => (
                  <a
                    key={s.id}
                    href={`#${s.id}`}
                    className="flex items-center gap-2 text-sm text-[#3B5249] hover:text-[#14A085] py-1"
                  >
                    <ChevronRight size={12} className="text-[#14A085]" />
                    {s.label}
                  </a>
                ))}
              </nav>
              <div className="mt-4 pt-4 border-t border-[#E2E8E5] space-y-1 text-xs">
                <Link to="/terms" className="block text-[#3B5249] hover:text-[#14A085]">Terms &amp; Conditions</Link>
                <Link to="/privacy" className="block text-[#3B5249] hover:text-[#14A085]">Privacy Policy</Link>
                <Link to="/return-policy" className="block text-[#3B5249] hover:text-[#14A085]">Return Policy</Link>
                <Link to="/refund-policy" className="block text-[#3B5249] hover:text-[#14A085]">Refund Policy</Link>
                <Link to="/shipping-policy" className="block text-[#3B5249] hover:text-[#14A085]">Shipping Policy</Link>
                <Link to="/faqs" className="block text-[#3B5249] hover:text-[#14A085]">FAQs</Link>
              </div>
            </div>
          </aside>
        )}
        <article className="prose prose-neutral max-w-none text-[#3B5249] leading-relaxed">
          {children}
        </article>
      </div>
    </div>
  );
}

export function Section({ id, title, children }) {
  return (
    <section id={id} className="mb-10 scroll-mt-24" data-testid={`policy-section-${id}`}>
      <h2 className="font-display text-2xl text-[#0F3D2E] mb-3 tracking-tight">{title}</h2>
      <div className="space-y-3 text-[15px] leading-7">{children}</div>
    </section>
  );
}
